import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Lock18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path d='M8.25 11V14H9.75V11H8.25Z' fill='currentColor' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4.25 5V7.25H3.5C2.72904 7.25 2.25 7.92311 2.25 8.5625V16.4375C2.25 17.0769 2.72904 17.75 3.5 17.75H14.5C15.271 17.75 15.75 17.0769 15.75 16.4375V8.5625C15.75 7.92311 15.271 7.25 14.5 7.25H13.75V5C13.75 2.41283 11.5872 0.25 9 0.25C6.41283 0.25 4.25 2.41283 4.25 5ZM9 1.75C7.22983 1.75 5.75 3.22983 5.75 5V7.25H12.25V5C12.25 3.22983 10.7702 1.75 9 1.75ZM3.75 8.75V16.25H14.25V8.75H3.75Z'
      fill='currentColor'
    />
  </Svg>
);

Lock18.displayName = 'Lock18';
export default Lock18;
